import { createContext, useContext, useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { fetchBMWData } from '../services/ioBroker'
import { fetchCarChargeSummary } from '../services/influxdb'
import { fetchCarDeparture } from '../services/carDeparture'

const VehicleContext = createContext(null)

export function useVehicle() {
  return useContext(VehicleContext)
}

export function VehicleProvider({ children }) {
  // Polling owned by DataContext; this subscribes to the cached value only.
  const bmwQ = useQuery({ queryKey: ['bmw'], queryFn: fetchBMWData, enabled: false })
  const chargeQ = useQuery({ queryKey: ['carChargeSummary'], queryFn: fetchCarChargeSummary, enabled: false })
  const departureQ = useQuery({ queryKey: ['carDeparture'], queryFn: fetchCarDeparture, enabled: false })

  const value = useMemo(() => ({
    bmw: bmwQ.data ?? null,
    chargeSummary: chargeQ.data ?? null,
    departure: departureQ.data ?? null,
  }), [bmwQ.data, chargeQ.data, departureQ.data])

  return <VehicleContext.Provider value={value}>{children}</VehicleContext.Provider>
}
